import styled from 'styled-components'

export const ThemeIcon = styled.i`
  color: var(--color-secondary);
  font-size: 1.4rem;

  animation-name: fadeInAnimation;
  animation-duration: 333ms;
  animation-delay: 0ms;
  animation-fill-mode: backwards;

  @keyframes fadeInAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @media only screen and (max-width: 1300px) {
    font-size: 20px;
  }
`
